import { Component, ComponentRef, Type, Input, ViewChild, ViewContainerRef, AfterViewInit, ComponentFactoryResolver, OnInit } from '@angular/core';
import { FailureStateComponent } from '../failure/failure.state';
import { GeneratedStateComponent } from '../generated/generated.state';
import { InitialStateComponent } from '../initial/initial.state';
import { ReceivedStateComponent } from '../received/received.state';
import { IContractState } from '../state.interface';
import { UploadingStateComponent } from '../uploading/uploading.state';
import { ContractStateDirective } from './state-context.directive';
import { IContractStateContext } from './state-context.interface';

import { DataSourceService } from './../../../services/data-source.service';
//-------------------------------------------------------------------------------------------
@Component({
  selector: 'lib-contract-state',
  templateUrl: './state-context.component.html',
  styleUrls: ['./state-context.component.css']
})
export class ContractStateContextComponent implements OnInit, AfterViewInit, IContractStateContext {
  constructor(private componentFactoryResolver: ComponentFactoryResolver, private dataService: DataSourceService) { }
  viewContainerRef!: ViewContainerRef;
  componentRef!: ComponentRef<IContractState>;
  contract : any;
  @ViewChild(ContractStateDirective, { static: true }) addHost: ContractStateDirective;
  @Input() ssID: any;
  @Input() employeeNumber: string;

  // -------------------------------------------------------------------------------------------
  ngOnInit(): void {
    this.listenContract();
  }
  // -------------------------------------------------------------------------------------------
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.viewContainerRef = this.addHost.viewContainerRef;
      this.setInitialState();
    }, 0);
  }
  // -------------------------------------------------------------------------------------------
  private listenContract(): void {
    //ESCUCHAR EL DOCUMENTO shareSavings/{{employeeNumber}}/savingContract/activeContract
    //crear el objeto Contract si existe
    this.dataService.loadSavingContract(this.ssID).subscribe(res => {

      this.contract = res ? res : null;
      
      if (this.contract != null) {
        if (this.contract.status == "filled") {
          this.setGeneratedState();
        } else if (this.contract.status == "signed") {
          this.setReceivedState();
        } else if (this.contract.status == "approved") {
          this.setReceivedState();
        }
      }
    })


  }
  // -------------------------------------------------------------------------------------------
  get componentType(): Type<IContractState> { return this.componentRef.componentType };
  // -------------------------------------------------------------------------------------------
  setState(component: Type<IContractState>): void {
    this.viewContainerRef.clear();
    this.componentRef = this.viewContainerRef.createComponent(
      this.componentFactoryResolver.resolveComponentFactory(component)
    );
    this.componentRef.instance.context = this;
  }
  // -------------------------------------------------------------------------------------------
  setInitialState(): Type<IContractState> {
    this.setState(InitialStateComponent);
    return this.componentType
  }
  // -------------------------------------------------------------------------------------------
  setGeneratedState(): Type<IContractState> {
    this.setState(GeneratedStateComponent);
    (<GeneratedStateComponent>this.componentRef.instance).contract = this.contract;
    return this.componentType
  }
  // -------------------------------------------------------------------------------------------
  setUploadingState(file: File): Type<IContractState> {
    this.setState(UploadingStateComponent);
    (<UploadingStateComponent>this.componentRef.instance).file = file;
    (<UploadingStateComponent>this.componentRef.instance).employeeNumber = this.employeeNumber;
    (<UploadingStateComponent>this.componentRef.instance).ssID = this.ssID;
    
    return this.componentType
  }
  // -------------------------------------------------------------------------------------------
  setReceivedState(): Type<IContractState> {
    this.setState(ReceivedStateComponent);
    return this.componentType
  }
  // -------------------------------------------------------------------------------------------
  setFailureState(): Type<IContractState> {
    this.setState(FailureStateComponent)
    return this.componentType
  }
  // -------------------------------------------------------------------------------------------
  nextState(): void {
    this.componentRef.instance.nextState();
  }
  // -------------------------------------------------------------------------------------------
}

